<template>
  <div v-if="tableData">
    <updated-list-component
      :table-headers="columnNames"
      :table-data="generateRoutePlannerData(tableData)"
      @client-clicked="onClientNameClicked($event)"
      @open-plan-route="onOpenRoutePlannerTabs($event,0)"
      @open-routes-tab="onOpenRoutePlannerTabs($event,1)"
    />
  </div>
</template>

<script>
import UpdatedListComponent from '../../uiUtils/UpdatedListComponent.vue'
import avatarColors from '../../../utils/avatarColors'

export default {
  components: { UpdatedListComponent },

  props: {
    columnNames: {
      type: Array,
      required: true
    },
    tableData: {
      type: Array,
      default: () => []
    }
  },

  data: function() {
    return { colors: avatarColors }
  },

  methods: {
    generateRoutePlannerData(tableDataArray) {
      let responseData = []
      tableDataArray.forEach((item, index) => {
        let rowObject = {}
        rowObject[0] = {
          type: 'avatar',
          class: 'textLeft',
          text: item.name,
          data: { value: item, action: 'client-clicked' } }
        rowObject[1] = {
          type: 'clickableText',
          class: 'text-xs-center',
          text: item.planRoute,
          data: { value: item, action: 'open-plan-route' }
        }
        rowObject[2] = {
          type: 'clickableText',
          class: 'text-xs-center',
          text: item.requestShowings,
          data: { value: item, action: 'open-routes-tab' }
        }
        rowObject[3] = {
          type: 'clickableText',
          class: 'text-xs-center',
          text: item.sendSchedule,
          data: { value: item, action: 'open-routes-tab' }
        }
        rowObject[4] = {
          type: 'clickableText',
          class: 'text-xs-center',
          text: item.scheduled,
          data: { value: item, action: 'open-routes-tab' }
        }
        if (item.planRoute !== 0 || item.requestShowings !== 0 || item.sendSchedule !== 0 || item.scheduled !== 0) {
          responseData.push(rowObject)
        }
      })
      return responseData
    },

    onOpenRoutePlannerTabs(client, num) {
      this.$emit('open-routes-planner-tab', { client, num })
    },

    onClientNameClicked(data) {
      this.$emit('client-clicked', data)
    }
  }
}
</script>

<style lang="sass" scoped>
.name
  color: $hwayzNested !important

.theme--light.v-table thead th
  color: $hwayzBlack
  font-weight: 500 !important

.theme--light.v-table tbody tr:not(:last-child)
  border-style: none

.avatar-margin
  margin-right: 15px

.white-override
  color: $hwayzWhite !important
</style>
